import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  useToast,
  Text,
  Box
} from "@chakra-ui/react";

import {
  useEffect,
  useState
} from "react";

function formatCPF(value: string) {

  const cleaned =
    value.replace(/\D/g, "");

  if (cleaned.length <= 3) {

    return cleaned;

  } else if (cleaned.length <= 6) {

    return cleaned.slice(0, 3) +
      "." +
      cleaned.slice(3);

  } else if (cleaned.length <= 9) {

    return cleaned.slice(0, 3) +
      "." +
      cleaned.slice(3, 6) +
      "." +
      cleaned.slice(6);

  } else {

    return cleaned.slice(0, 3) +
      "." +
      cleaned.slice(3, 6) +
      "." +
      cleaned.slice(6, 9) +
      "-" +
      cleaned.slice(9, 11);

  }
}

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  initialData?: any;
}

export default function FormModal({
  isOpen,
  onClose,
  onSave,
  initialData
}: Props) {

  const toast = useToast();

  const [form, setForm] =
    useState({
      numero_lideranca: "",
      nome: "",
      cpf: ""
    });

  const [error, setError] =
    useState<string | null>(null);

  const [loading, setLoading] =
    useState(false);

  useEffect(() => {

    if (initialData) {

      setForm({
        numero_lideranca:
          initialData.numero_lideranca ?? "",
        nome:
          initialData.nome ?? "",
        cpf:
          formatCPF(
            initialData.cpf ?? ""
          )
      });

    } else {

      setForm({
        numero_lideranca: "",
        nome: "",
        cpf: ""
      });

    }

    setError(null);

  }, [initialData, isOpen]);

  function handleSave() {

    setError(null);

    if (!form.numero_lideranca) {

      setError(
        "Informe o número."
      );

      return;
    }

    if (form.nome.trim().length < 3) {

      setError(
        "Nome inválido."
      );

      return;
    }

    const cpf =
      form.cpf.replace(/\D/g, "");

    if (form.cpf && cpf.length !== 11) {

      setError(
        "CPF inválido."
      );

      return;
    }

    setLoading(true);

    onSave(form);
  }

  return (

    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
    >

      <ModalOverlay />

      <ModalContent>

        <ModalHeader>

          {initialData
            ? "Editar Liderança"
            : "Nova Liderança"}

        </ModalHeader>

        <ModalBody>

          <VStack spacing={4}>

            <FormControl>

              <FormLabel>
                Número
              </FormLabel>

              <Input
                value={
                  form.numero_lideranca
                }
                onChange={(e) =>
                  setForm({
                    ...form,
                    numero_lideranca:
                      e.target.value
                  })
                }
              />

            </FormControl>

            <FormControl>

              <FormLabel>
                Nome
              </FormLabel>

              <Input
                value={form.nome}
                onChange={(e) =>
                  setForm({
                    ...form,
                    nome:
                      e.target.value
                  })
                }
              />

            </FormControl>

            <FormControl>

              <FormLabel>
                CPF (opcional)
              </FormLabel>

              <Input
                value={form.cpf}
                onChange={(e) =>
                  setForm({
                    ...form,
                    cpf:
                      formatCPF(
                        e.target.value
                      )
                  })
                }
                placeholder="000.000.000-00"
              />

            </FormControl>

            {error && (

              <Box
                p={3}
                bg="red.100"
                borderRadius="md"
              >

                <Text
                  color="red.700"
                  fontSize="sm"
                >
                  {error}
                </Text>

              </Box>

            )}

          </VStack>

        </ModalBody>

        <ModalFooter>

          <Button
            mr={3}
            onClick={() => {

              setLoading(false);

              onClose();
            }}
          >
            Cancelar
          </Button>

          <Button
            colorScheme="blue"
            onClick={handleSave}
            isLoading={loading}
          >
            Salvar
          </Button>

        </ModalFooter>

      </ModalContent>

    </Modal>
  );
}